import { ChecklistStepEntity } from './checklist-step.entity';

export class ChecklistEntity {
  public id!: string;
  public displayOnInvestigations!: boolean;
  public steps!: ChecklistStepEntity[];
}
